import { AUTH_TOKEN_KEY, AUTH_USER_KEY, AUTH_RTOKEN_KEY } from '../constants';

const SessionManager = {
    setAuthToken: function (authToken) {
        if (authToken) {
            localStorage.setItem(AUTH_TOKEN_KEY, authToken);
        } else {
            localStorage.removeItem(AUTH_TOKEN_KEY, authToken);
        }
    },
    setAuthRToken: function (authToken) {
        if (authToken) {
            localStorage.setItem(AUTH_RTOKEN_KEY, authToken);
        } else {
            localStorage.removeItem(AUTH_RTOKEN_KEY, authToken);
        }
    },
    setAuthUser: function (authUser) {
        if (authUser) {
            localStorage.setItem(AUTH_USER_KEY, JSON.stringify(authUser));
        } else {
            localStorage.removeItem(AUTH_USER_KEY);
        }
    },
    getAuthUser: function () {
        try {
            return JSON.parse(localStorage.getItem(AUTH_USER_KEY));
        } catch (e) { }

        return {
            user: {},
            isSignedIn: false
        };
    },
    getAuthToken: function () {
        return localStorage.getItem(AUTH_TOKEN_KEY);
    },
    getAuthRToken: function () {
        return localStorage.getItem(AUTH_RTOKEN_KEY);
    }
}

export default SessionManager;